import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Home from "./pages/home";
import NotFound from "./pages/not-found";
import UnderConstruction from "./pages/under-construction";
import Test from "./pages/test";
import {
  // BrowserRouter as Router,
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import quoteData from "./data/quotes";

function App() {
  function putRandomQuote() {
    let quotes = quoteData;

    let randomQuote = quotes[Math.floor(Math.random() * quotes.length)];

    return randomQuote;
  }

  let year = new Date().getFullYear() || 2020;
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route path="/projects">
          <UnderConstruction />
        </Route>
        <Route path="/beta">
          <Redirect to="/" />
          {/* <Test /> */}
        </Route>
        <Route path="/resume">
          {() => {
            window.location.href = "/docs/resume.pdf";
            return null;
          }}
        </Route>

        <Route exact path="/instagram">
          {() => {
            window.location.href = "https://instagram.com/rohantinna";
            return null;
          }}
        </Route>

        {/* Githib */}
        <Route exact path="/github">
          {() => {
            window.location.href = "https://github.com/rohantinna";
            return null;
          }}
        </Route>

        {/* Twitter */}
        <Route exact path="/twitter">
          {() => {
            window.location.href = "https://twitter.com/rohantinna";
            return null;
          }}
        </Route>

        {/* Medium */}
        <Route exact path="/medium">
          {() => {
            window.location.href = "https://medium.com/@rohantinna";
            return null;
          }}
        </Route>

        {/* LinkedIn */}
        <Route exact path="/linkedin">
          {() => {
            window.location.href = "https://linkedin.com/in/rohantinna";
            return null;
          }}
        </Route>

        <Route exact path="/blog">
          <Redirect to="/medium" />
        </Route>

        <Route exact path="/">
          <Home />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
      <span id="copyright" className="noselect">
        &copy; Copyright {year}.
      </span>

      <div id="right-click" className="noselect">
        <h3>
          {/* <pre> */}
          {/* Made with <span className="heart">&hearts;</span> by Rohan */}
          {"“"}
          {putRandomQuote()}
          {"”"}
          {/* </pre> */}
        </h3>
        <p>
          &copy; Copyright {year}. <a href="#">Version 2.1.0</a>.
        </p>
      </div>
    </Router>
  );
}

export default App;
